import React from "react";
import { Box, Typography } from "@mui/material";
import { AlertBanner } from "@dishopsaas/design-system";
import { calculateUserPoints } from "../../utils/order";

type LoyaltyBannerProps = {
  commande: any;
};

const LoyaltyBanner: React.FC<LoyaltyBannerProps> = ({ commande }) => {
  const { pointsEarned } = calculateUserPoints(commande);
  if (!pointsEarned) return null;

  return (
    <AlertBanner
      severity="success"
      message={
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1">
            Vous gagnez{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              +{pointsEarned}
            </Box>{" "}
            points avec cette commande.
          </Typography>
        </Box>
      }
      iconName="Award"
      noShadow
    />
  );
};

export default LoyaltyBanner;
